export const unit = (factor: number = 1) => factor * 8;

export const BORDER_RADIUS = 8;
